// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"b5bc31b7","310":"8e3172cc","854":"6e5f98a9"}[chunkId] + ".chunk.css";
};